import {useForm} from 'react-hook-form'
import storage from 'services/storage'
import {useI18n, useLoginMutation} from 'store/Store'
import {useNavigate} from 'services/hooks'
import {useEffect} from 'react'
import useUserInfo from 'logic/Auth/useUserInfo.js'

const useLogin = () => {
    const {i18n} = useI18n()
    const navigate = useNavigate()
    const [doLogin, {error, isLoading}] = useLoginMutation()
    const {user, isLoggedIn} = useUserInfo()
    const loginError = error?.data?.message || error?.data?.message?.message

    useEffect(() => {
        if (isLoggedIn) {
            navigate('/')
        }
    }, [isLoggedIn, navigate])

    const {
        getValues: getFormValues,
        setValue: setFormValue,
        handleSubmit,
        control: formControl,
        formState: {errors: formErrors},
    } = useForm()

    const onSubmit = (submittedData) => {
        storage.setRememberMe(submittedData.rememberMe || false)
        doLogin(submittedData)
    }

    const submit = handleSubmit(onSubmit)
    const translate = (label) => i18n.t('welcome.' + label)

    return {
        user,
        formControl,
        submit,
        loginError,
        formErrors,
        getFormValues,
        setFormValue,
        translate,
        navigate,
        isLoading,
    }
}

export default useLogin
